import React, { useState } from 'react';
import Pagination from '../../Common/Pagination';
import SectionHeader, { SectionHeaderTypes } from '../../Common/SectionHeader'

export default function MapList({ selected, documentList, onSelectDoc, viewDoc, downloadDoc, downloadAll, selectedPage = 1, onSelectPage }) {
    const numberFormatter = new Intl.NumberFormat('en-US', { style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2 });
    const dateFormatter = new Intl.DateTimeFormat('en-US', { day: "2-digit", month: "2-digit", year: "numeric" });
    // const [selectedPage, setSelectedPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [sortedBy, setSortedBy] = useState('created');
    const [sortOrder, setSortOrder] = useState('desc');

    // function handleSelectPage(pageNum) { setSelectedPage(pageNum); }

    function handleSortByAndOrder(sortByAndOrder) {
        const [sortByParm, sortOrderParam] = sortByAndOrder.split("-");

        setSortOrder(sortOrderParam);
        setSortedBy(sortByParm);
    }

    function handleSortBy(sortBy) {
        let newSortOrder = sortOrder === 'desc' ? 'asc' : 'desc';

        setSortOrder(sortedBy === sortBy ? newSortOrder : 'desc');
        setSortedBy(sortBy);
    }

    function getSortComparer() {
        let isDesc = sortOrder === "desc";
        let compareFn = undefined;
        switch (sortedBy?.toLowerCase()) {
            case 'revision':
                compareFn = (a, b) => (isDesc ? b.latestRevision.revisionNumber - a.latestRevision.revisionNumber : a.latestRevision.revisionNumber - b.latestRevision.revisionNumber);
                break;
            case 'description':
                compareFn = (a, b) => (isDesc ? ('' + b.description).localeCompare(a.description) : ('' + a.description).localeCompare(b.description));
                break;
            case 'created':
            default:
                //sortBy = "created";
                compareFn = (a, b) => {
                    const timeA = new Date(a.latestRevision.createdAt).getTime();
                    const timeB = new Date(b.latestRevision.createdAt).getTime();
                    return isDesc ? timeB - timeA : timeA - timeB;
                };
                break;
        }

        return compareFn;
    }

    let content;

    if (documentList.length > 0) {

        let compareFn = getSortComparer(sortedBy, sortOrder);
        let sortedDocList = documentList.toSorted(compareFn);

        let selectedCount = sortedDocList.filter(doc => doc.selected).length;

        let shownDocumentList = sortedDocList.slice((pageSize * selectedPage) - pageSize, (pageSize * selectedPage));

        let documentItems = shownDocumentList.map((doc, i) => {
            let viewBtn = (<button className="button" onClick={() => viewDoc(doc.latestRevision)}>View</button>);

            let downloadBtn = (<button className="button" onClick={() => downloadDoc(doc.latestRevision)}>Download</button>);
            if (selectedCount > 0) {
                downloadBtn = (<button className="button disabled">Download</button>);
            }


            let selectDoc = onSelectDoc && (<span className="select" onClick={() => onSelectDoc(undefined, doc.id)}>
                <i className={doc.selected ? "dhicon-check-2" : "dhicon-check-empty"} />
            </span>);


            return (<tr key={`${doc.id}-${doc.latestRevision.revisionId}-${i}`}>
                <td className="compact">{selectDoc}</td>
                <td className="compact tabular-nums">{doc.latestRevision.createdAt ? dateFormatter.format(new Date(doc.latestRevision.createdAt)) : '-/-/-'}</td>
                <td className="compact">{doc.latestRevision.revisionNumber}</td>
                <td className="">{doc.description}</td>
                <td className="compact">{downloadBtn}</td>
                <td className="compact">{viewBtn}</td>
                <td className="smallScreen text-[10pt]">
                    <div className="flex flex-auto w-full">
                        {selectDoc}
                        <div className="flex flex-auto flex-col">
                            <div className="flex">
                                <div className="flex flex-auto">
                                    <span className="font-semibold w-14 shrink-0">Date: </span>
                                    <span>{doc.latestRevision.createdAt ? dateFormatter.format(new Date(doc.latestRevision.createdAt)) : '-/-/-'}</span>
                                </div>
                                <div className="flex flex-auto">
                                    <span className="font-semibold w-[70px] shrink-0">Revision: </span>
                                    <span>{doc.latestRevision.revisionNumber}</span>
                                </div>
                            </div>
                            <div className="flex">
                                <span className="font-semibold w-14 shrink-0">Name: </span>
                                <span>{doc.description}</span>
                            </div>
                            <div className="buttonContainer">
                                {downloadBtn}
                                {viewBtn}
                            </div>
                        </div>
                    </div>
                </td>
            </tr>);
        });

        if (selectedPage > 1 && pageSize - documentItems.length > 0) {
            let emptyRows = Array.from(
                { length: pageSize - documentItems.length },
                (cv, i) => (<tr className="noBkg" key={`R${i}`}><td><button className="button hide">&nbsp;</button></td></tr>));
            documentItems = documentItems.concat(emptyRows);
        }

        let selectAll = onSelectDoc && (<span className="selectAll flex cursor-pointer text-center" onClick={() => onSelectDoc(true)}>
            <i className={`${selected ? "dhicon-check-2" : "dhicon-check-empty"} text-lg`} />
            <div>Select</div>
        </span>);

        let sortSelect = (<select className="bg-drhPalette-secondary " onChange={(e) => handleSortByAndOrder(e.target.value)} value={`${sortedBy}-${sortOrder}`}>
            <option className="checked:font-semibold checked:text-white" value='created-desc'>Date desc</option>
            <option className="checked:font-semibold checked:text-white" value='created-asc'>Date asc</option>
            <option className="checked:font-semibold checked:text-white" value='revision-desc'>Revision desc</option>
            <option className="checked:font-semibold checked:text-white" value='revision-asc'>Revision asc</option>
            <option className="checked:font-semibold checked:text-white" value='description-desc'>Name desc</option>
            <option className="checked:font-semibold checked:text-white" value='description-asc'>Name asc</option>
        </select>);

        let selectBarSmallScreen = (<SectionHeader classes="selectAllSmallScreen m-1 pl-0.5 justify-between" sectionHeaderType={SectionHeaderTypes.Secondary}>
            <div className="flex items-center">
                {selectAll}
            </div>
            <div className="text-base">
                <span className="hidden xsm:inline">Sort by</span>
                {sortSelect}
            </div>
        </SectionHeader>);

        let downloadAllBtn = selectedCount > 0 && (<button className="button" onClick={() => downloadAll()}>Download</button>);
        let pagination = (<Pagination itemCount={documentList.length} pageSize={pageSize} selectedPage={selectedPage} hideWhenSinglePage={false} onSelectPage={onSelectPage}>{downloadAllBtn}</Pagination>);

        let sortIconClass = sortOrder === 'desc' ? 'dhicon-down-open' : 'dhicon-up-open';

        //let sortableIcon = (<span className="flex"><i className="dhicon-up-open relative -top-1" /><i className="dhicon-down-open relative top-[3px] -left-[22.5px]" /></span>);
        //let sortableColDescClass = "relative -left-[22px]";
        let sortableIcon = (<i className="iconUpDown" />);
        let sortableColDescClass = "";

        let createdAtHeader = (<th onClick={() => handleSortBy('created')} className="cursor-pointer">
            <div className="flex">
                {sortedBy === 'created' ? (<i className={sortIconClass} />) : (sortableIcon)}
                <span className={sortedBy !== 'created' ? sortableColDescClass : ''}>Date</span>
            </div>
        </th>);

        let revisionHeader = (<th onClick={() => handleSortBy('revision')} className="cursor-pointer">
            <div className="flex">
                {sortedBy === 'revision' ? (<i className={sortIconClass} />) : (sortableIcon)}
                <span className={sortedBy !== 'revision' ? sortableColDescClass : ''}>Revision</span>
            </div>
        </th>);

        let nameHeader = (<th onClick={() => handleSortBy('description')} className="cursor-pointer">
            <div className="flex">
                {sortedBy === 'description' ? (<i className={sortIconClass} />) : (sortableIcon)}
                <span className={sortedBy !== 'description' ? sortableColDescClass : ''}>Name</span>
            </div>
        </th>);

        content = documentItems.length === 0 ? undefined : (<>
            {selectBarSmallScreen}
            <table className="itemList">
                <thead>
                    <tr>
                        <th>{selectAll}</th>
                        {createdAtHeader}
                        {revisionHeader}
                        {nameHeader}
                        <th colSpan="2">Actions</th>
                    </tr>
                </thead>
                <tbody>{documentItems}</tbody>
            </table>
            {/*pagination*/}
        </>);
    }

    return content;
}